import PropTypes from 'prop-types';
import DatasourceBaseOauthNew from "../Datasources/DatasourceBaseOauthNew.jsx";

const DatasourceGoHighLevel = (props) => {

    const ClientId = "69932ed60da651ba3554c83a-mlpath7t"
    const Scope = "contacts.readonly+contacts.write+users.readonly"
    const RedirectUrl = "https://auth.cloudcti.nl/webapi/oauth2"
    const AuthUrl = "https://marketplace.gohighlevel.com/oauth/chooselocation?scope=" + Scope + "&client_id=" + ClientId + "&response_type=code&version_id=69932ed60da651ba3554c83a&redirect_uri=" + RedirectUrl

    return <DatasourceBaseOauthNew SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} CrmServerTokenController="/api/gohighlevel/tokens" OtherOauthResultFields={{locationId: "LocationId"}} OnSetReady={props.OnSetReady}/>
}

DatasourceGoHighLevel.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceGoHighLevel